export default __webpack_public_path__ + "static/media/icons-accounts.5c15bf80.svg";